import React, { createContext, useContext, useState } from "react";

const OrderCtx = createContext(null);

const DEFAULT = {
  boxSize: null,
  items: {}, // {flavor_id: qty}
  method: null,
  address: { street: "", city: "", state: "SC", zip: "" },
  delivery: { checked: false, eligible: false, distance: 0, fee: 0, message: "" },
  tipPercent: 10,
  tipCustom: "",
};

export function OrderProvider({ children }) {
  const [state, setState] = useState(DEFAULT);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));
  const reset = () => setState(DEFAULT);
  return <OrderCtx.Provider value={{ ...state, update, reset, setState }}>{children}</OrderCtx.Provider>;
}

export const useOrder = () => useContext(OrderCtx);
